import { register } from "@shared/services/propertyRendererRegistry";
import StatusTagRenderer from "@shared/components/tickets/components/StatusTagRenderer.vue";
import PrioritySelect from "@shared/components/tickets/components/PrioritySelect.vue";
import { dataQualityTicketType } from "./constants";

register({
  twinTypePattern: dataQualityTicketType,
  customId: "status",
  viewComponentTable: StatusTagRenderer,
  viewComponentDetail: StatusTagRenderer,
});

register({
  twinTypePattern: dataQualityTicketType,
  customId: "priority",
  editComponent: PrioritySelect,
});
